import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx-ugnis";
import { useState } from "react";
import { useUploaderFlow } from "../../hooks/useUploaderFlow";
import ToasterService from "../../../../../core/toaster/ToasterService";
import I18n from "../../../../../core/localization/I18n";
import { TOASTER_TOAST_TIME } from "../../../../../core/toaster/Toaster_model";
import { Button } from "../../../Button";
import { readFileAsync } from "./utils/readFilesAsync";
import "./_dropzone.scss";

type DropZoneProps = {
  onContinue: (data: XLSX.WorkBook, file: File) => void;
  isLoading: boolean;
};

export const DropZone = ({ onContinue, isLoading }: DropZoneProps) => {
  const { maxFileSize, dateFormat, parseRaw } = useUploaderFlow();
  const [loading, setLoading] = useState(false);
  const toast = ToasterService;
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxFiles: 1,
    maxSize: maxFileSize,
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      "text/csv": [".csv"]
    },
    onDropRejected: fileRejections => {
      setLoading(false);

      fileRejections.forEach(fileRejection => {
        toast.showErrorToast(TOASTER_TOAST_TIME.SLOW).setContent(
          <div>
            {`${fileRejection.file.name}`}
            <br />
            <strong>{`${I18n.t("warnings.uploadStepDropzoneErrorToastDescription")}`}</strong>
          </div>
        );
      });
    },
    onDropAccepted: async ([file]) => {
      setLoading(true);
      const arrayBuffer = await readFileAsync(file);
      const workbook = XLSX.read(arrayBuffer, {
        cellDates: true,
        dateNF: dateFormat,
        raw: parseRaw,
        dense: true,
        codepage: 65001
      });
      setLoading(false);
      onContinue(workbook, file);
    }
  });

  return (
    <div
      {...getRootProps()}
      className="dropzone__wrapper w-100 d-flex flex-column justify-content-center align-items-center"
    >
      <input {...getInputProps()} data-testid="insight-dropzone" />
      {isDragActive ? (
        <p className="dropzone__txt">{I18n.t("phrases.uploadStepDropzoneActiveDropzoneTitle")}</p>
      ) : loading || isLoading ? (
        <p className="dropzone__txt">{I18n.t("phrases.uploadStepDropzoneLoadingTitle")}</p>
      ) : (
        <>
          <p className="dropzone__txt">{I18n.t("phrases.uploadStepDropzoneTitle")}</p>
          <Button onClick={open}>{I18n.t("phrases.uploadStepDropzoneButtonTitle")}</Button>
        </>
      )}
    </div>
  );
};
